import { useTranslation } from "react-i18next";
import useSWR from "swr";
import { fetchTokenBalance } from "~/api/endpoints";
import { useUXUYWallet } from "~/Provider/UXUYWallet";
import {
    formatAmount,
    formatBalance,
    formatPrice,
} from "~/utils/number-format";

export default function KDetailBalance({ chain_id, contract }: any) {
    const { t } = useTranslation();
    const { getAddress, getAddressType } = useUXUYWallet();

    const initData = (args: any) => {
        const [_, chain_id, contract] = args;
        const address = getAddress(chain_id) as string;
        const address_type = getAddressType(chain_id) as number;
        return fetchTokenBalance({
            chain_id,
            contract,
            address,
            address_type,
        }).then((res) => res?.data || {});
    };

    const { data } = useSWR(
        ["k-detail:apiTokenBalance", chain_id, contract],
        initData,
        {
            fallbackData: {},
        }
    );

    return (
        <div className="px-[16px] py-[24px] border-b-[0.5px] border-border_2">
            <div className="text-h4 font-Semibold text-text_1">
                {t("your_balance")}
            </div>
            <div className="flex mt-[12px]">
                <div className="w-1/2">
                    <div className="text-direction1 font-Regular text-text_2">
                        {t("market-detail-list-col3")}
                    </div>
                    <div className="text-h5 font-Semibold text-text_1 mt-[1px] whitespace-nowrap">
                        {formatPrice(data.value)}
                    </div>
                </div>
                <div className="w-1/2">
                    <div className="text-direction1 font-Regular text-text_2">
                        {t("quantity")}
                    </div>
                    <div className="text-h5 font-Semibold text-text_1 mt-[1px] whitespace-nowrap">
                        {formatBalance(data.balance || 0)}
                    </div>
                </div>
            </div>
        </div>
    );
}
